/**
 * Created by lu on 2018/5/8.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent: require('./Dialog'),
    slot: {
        content: ['html', [{
            'class': 'iconfont icon-xinxi-',
            tag: 'i'
        }, {
            $html: '请进一步完善公司信息，通过审核后可进行商品购买!<br>也可稍后到用户中心里完善公司信息！'
        }]],
        footer: ['html', [{
            tag: 'a',
            href: 'companyInfo.html',
            class:'btn btn-solid-gold btn-md',
            $text:'完善信息'
        },{
            tag: 'a',
            href: 'index.html',
            class:'btn btn-line-gold btn-md',
            $text:'先看看'
        }]]
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/modal/CompleteInformation.js
// module id = 96
// module chunks = 6 32 35 36